import { useState, useRef, useEffect } from "react";
import { Button } from "./ui/button";
import { Bookmark, Star, Trash2 } from "lucide-react";

export default function SavedFiltersMenu({ filters, onApply, onDelete }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open]);

  if (filters.length === 0) return null;

  return (
    <div className="relative" ref={menuRef}>
      <Button 
        variant="outline" 
        size="sm" 
        className="h-8"
        onClick={() => setOpen(!open)}
        data-testid="saved-filters-btn"
      >
        <Bookmark className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" />
        <span className="hidden sm:inline">Salvati ({filters.length})</span>
      </Button>
      
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 w-56 bg-popover border border-border rounded-md shadow-lg py-1 animate-in fade-in-0 zoom-in-95">
          {filters.map((sf) => (
            <div
              key={sf.id}
              className="flex items-center justify-between px-3 py-2 hover:bg-secondary transition-colors cursor-pointer"
              onClick={() => {
                onApply(sf);
                setOpen(false);
              }}
            >
              <div className="flex items-center gap-2 truncate">
                <Star className="w-4 h-4 text-amber-500 flex-shrink-0" />
                <span className="truncate text-sm">{sf.name}</span>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6 flex-shrink-0"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(sf.id, e);
                }}
              >
                <Trash2 className="w-3 h-3 text-destructive" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
